import * as React from 'react'

import { SettingsSectionWithTabs } from '../../components/SettingsSectionWithTabs'
import { FieldsetInput } from '../../components/FieldsetInput'
import { FieldsetSwitch } from '../../components/FieldsetSwitch'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { ScannerSettingsModel } from '@/lib/api/company/configuration/scanner'
import { DefaultScannerField } from './DefaultScannerField'

type Props = {
  isSaving: boolean
  state: ScannerSettingsModel
  setState: React.Dispatch<React.SetStateAction<ScannerSettingsModel | null>>
}

export const ScannerForm = ({ isSaving, state, setState }: Props) => {
  const { t } = useLocalize()

  const handleInputChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value, checked, type } = e.target
      setState((prev) =>
        prev
          ? {
              ...prev,
              // WPF trzyma jasność jako 0-100 i dopiero mostek mapuje ją na zakres
              // zgłoszony przez sterownik; poza tym przedziałem wyszłaby poza skalę.
              [name]:
                type === 'checkbox'
                  ? checked
                  : Math.min(100, Math.max(0, Number(value) || 0)),
            }
          : prev,
      )
    },
    [setState],
  )

  return (
    <SettingsSectionWithTabs>
      <div
        data-tab-name="a"
        title={t('configuration-scanner.section')}
        className="tw-flex tw-flex-col tw-gap-6 tw-p-2 tw-pb-8"
      >
        <DefaultScannerField />

        <FieldsetInput
          label={t('configuration-scanner.brightness')}
          value={state.scanBrightness.toString()}
          name="scanBrightness"
          type="number"
          min={0}
          max={100}
          step={1}
          placeholder=""
          onChange={handleInputChange}
          disabled={isSaving}
          bottomInfo={t('configuration-scanner.brightness-hint')}
        />

        {/* FieldsetSwitch nie ma bottomInfo, więc podpowiedź w tej samej typografii
            co przy polach tekstowych. */}
        <div>
          <FieldsetSwitch
            label={t('configuration-scanner.show-dialog')}
            checked={state.showScannerDialog}
            name="showScannerDialog"
            placeholder=""
            onChange={handleInputChange}
            disabled={isSaving}
          />
          <p className="tw-my-2 tw-p-1 tw-text-sm tw-text-neutral">
            {t('configuration-scanner.show-dialog-hint')}
          </p>
        </div>
      </div>
    </SettingsSectionWithTabs>
  )
}
